{
  "billing.nav": "Billing",
  "billing.subtitle": "Proposals, proformas and payment requests, what clients have paid and what we spend.",
  "billing.quotes.subtitle": "Proposals built in 404 OS or attached as a file.",
  "billing.invoices.subtitle": "Proformas and payment requests, and what is still owed.",
  "billing.payments.subtitle": "Transfers recorded against issued documents.",
  "billing.expenses.subtitle": "What the agency spends, by category and project.",
  "billing.overdueCount": "{count, plural, one {# overdue} other {# overdue}}",
  "billing.loadError": "We could not load billing.",
  "billing.newQuote": "New proposal",
  "billing.newRequest": "New payment request",
  "billing.newProforma": "New proforma",
  "billing.reports.nav": "Reports",
  "billing.side.label": "Billing details",
  "billing.readOnly": "You can follow billing here; finance issues documents and records payments.",
  "billing.kpi.outstanding": "Outstanding",
  "billing.kpi.overdue": "Overdue",
  "billing.kpi.collected": "Collected this month",
  "billing.kpi.credit": "Client credit",
  "billing.kpi.none": "Nothing",
  "billing.kpi.label": "Money at a glance",
  "billing.kpi.documents": "{count, plural, one {# document} other {# documents}}",
  "billing.tabs.label": "Billing documents",
  "billing.tab.quotes": "Proposals",
  "billing.tab.invoices": "Invoices",
  "billing.tab.payments": "Payments",
  "billing.filter.label": "Filter by status",
  "billing.search": "Search by number, title or client",
  "billing.filter.all": "All",
  "billing.filter.open": "Open",
  "billing.filter.overdue": "Overdue",
  "billing.filter.draft": "Drafts",
  "billing.filter.paid": "Paid",
  "billing.filter.void": "Void",
  "billing.filter.sent": "Waiting",
  "billing.filter.accepted": "Accepted",
  "billing.filter.declined": "Declined",
  "billing.filter.expired": "Expired",
  "billing.quoteStatus.draft": "Draft",
  "billing.quoteStatus.sent": "Sent",
  "billing.quoteStatus.accepted": "Accepted",
  "billing.quoteStatus.declined": "Declined",
  "billing.quoteStatus.expired": "Expired",
  "billing.invoiceStatus.draft": "Draft",
  "billing.invoiceStatus.issued": "Issued",
  "billing.invoiceStatus.partially_paid": "Partly paid",
  "billing.invoiceStatus.paid": "Paid",
  "billing.invoiceStatus.void": "Void",
  "billing.overdue": "Overdue",
  "billing.kind.proforma": "Proforma",
  "billing.kind.payment_request": "Payment request",
  "billing.method.instapay": "InstaPay",
  "billing.method.vodafone_cash": "Vodafone Cash",
  "billing.method.bank_transfer": "Bank transfer",
  "billing.method.cash": "Cash",
  "billing.method.client_credit": "Client credit",
  "billing.col.number": "Number",
  "billing.col.document": "Document",
  "billing.col.client": "Client",
  "billing.col.status": "Status",
  "billing.col.validUntil": "Valid until",
  "billing.col.due": "Due",
  "billing.col.total": "Total",
  "billing.col.outstanding": "Balance",
  "billing.col.date": "Date",
  "billing.col.method": "Method",
  "billing.col.amount": "Amount",
  "billing.col.reference": "Reference",
  "billing.draftNumber": "Draft",
  "billing.empty.quotes.title": "No proposals yet",
  "billing.empty.quotes.body": "Write a proposal, send it as a link, and the client accepts it online.",
  "billing.empty.invoices.title": "No invoices yet",
  "billing.empty.invoices.body": "Proformas and payment requests appear here once you raise them.",
  "billing.empty.payments.title": "No payments yet",
  "billing.empty.payments.body": "Record InstaPay, Vodafone Cash and bank transfers against an issued document.",
  "billing.noResults.title": "Nothing matches",
  "billing.noResults.body": "Try another status or another search.",
  "billing.noResults.clear": "Clear filters",
  "billing.proof.open": "Open proof of transfer",
  "billing.proof.upload": "Attach proof",
  "billing.proof.attached": "Proof attached",
  "billing.proof.none": "No proof",
  "billing.quote.new": "New proposal",
  "billing.quote.edit": "Edit proposal",
  "billing.invoice.new.proforma": "New proforma",
  "billing.invoice.new.payment_request": "New payment request",
  "billing.invoice.edit": "Edit draft",
  "billing.field.client": "Client",
  "billing.field.clientPlaceholder": "Choose a client",
  "billing.field.clientSearch": "Search clients",
  "billing.field.clientEmpty": "No client matches",
  "billing.field.project": "Project",
  "billing.field.projectPlaceholder": "No project",
  "billing.field.projectSearch": "Search projects",
  "billing.field.projectEmpty": "No project matches",
  "billing.field.title": "Title",
  "billing.field.titlePlaceholder": "Online store, phase 2",
  "billing.field.language": "Document language",
  "billing.language.ar": "Arabic",
  "billing.language.en": "English",
  "billing.field.currency": "Currency",
  "billing.field.tax": "VAT",
  "billing.field.validUntil": "Valid until",
  "billing.field.dueOn": "Due date",
  "billing.field.dueOnHint": "Leave empty for 14 days after issue.",
  "billing.field.kind": "Document",
  "billing.field.notes": "Notes",
  "billing.field.terms": "Terms",
  "billing.field.required": "Required",
  "billing.field.titleMissing": "Give the document a title.",
  "billing.field.clientMissing": "Choose who to bill.",
  "billing.section.parties": "Client and project",
  "billing.section.lines": "Lines",
  "billing.section.plan": "Payment plan",
  "billing.section.notes": "Notes and terms",
  "billing.section.totals": "Totals",
  "billing.line.description": "Description",
  "billing.line.service": "Service",
  "billing.line.noService": "No service",
  "billing.line.quantity": "Qty",
  "billing.line.price": "Unit price",
  "billing.line.discount": "Discount %",
  "billing.line.taxable": "VAT",
  "billing.line.amount": "Amount",
  "billing.line.add": "Add line",
  "billing.line.remove": "Remove line {number}",
  "billing.line.label": "Line {number}",
  "billing.line.empty": "Add the first line: what the client pays for.",
  "billing.line.invalid": "Check the quantity, price and discount.",
  "billing.line.missing": "Add at least one line.",
  "billing.plan.hint": "Split the payment into a deposit, milestones or dates. Without a plan, the client pays in full on acceptance.",
  "billing.plan.label": "Part",
  "billing.plan.percent": "Share %",
  "billing.plan.trigger": "When",
  "billing.plan.dueOn": "Date",
  "billing.trigger.on_acceptance": "On acceptance",
  "billing.trigger.on_milestone": "At a milestone",
  "billing.trigger.on_date": "On a date",
  "billing.plan.add": "Add part",
  "billing.plan.remove": "Remove part {number}",
  "billing.plan.sum": "Adds up to {percent}",
  "billing.plan.unbalanced": "The parts must add up to exactly 100%.",
  "billing.plan.deposit": "Deposit",
  "billing.plan.balance": "Balance",
  "billing.plan.dateMissing": "Choose the date.",
  "billing.totals.subtotal": "Subtotal",
  "billing.totals.discount": "Discount",
  "billing.totals.tax": "VAT {percent}",
  "billing.totals.noTax": "No VAT",
  "billing.totals.total": "Total",
  "billing.totals.paid": "Paid",
  "billing.totals.credited": "Credited",
  "billing.totals.outstanding": "Balance due",
  "billing.action.saveDraft": "Save draft",
  "billing.action.saved": "Draft saved",
  "billing.action.send": "Send proposal",
  "billing.action.sent": "Proposal {number} sent",
  "billing.send.title": "Send this proposal?",
  "billing.send.description": "It gets its number. After that it cannot change; duplicate it to make a new version.",
  "billing.action.issue": "Issue",
  "billing.issue.title": "Issue this document?",
  "billing.issue.description": "It gets the next number in its series and can no longer change. Mistakes are corrected with a credit note.",
  "billing.issue.done": "{number} issued",
  "billing.action.delete": "Delete draft",
  "billing.delete.title": "Delete this draft?",
  "billing.delete.description": "Drafts have no number yet, so nothing is lost from the series.",
  "billing.delete.done": "Draft deleted",
  "billing.action.print": "Download PDF",
  "billing.action.duplicate": "Duplicate",
  "billing.duplicate.done": "A copy was created as a draft",
  "billing.action.whatsapp": "Share on WhatsApp",
  "billing.action.record": "Record payment",
  "billing.action.creditNote": "Issue a credit note",
  "billing.action.void": "Void",
  "billing.action.applyCredit": "Use client credit",
  "billing.action.decline": "Record a decline",
  "billing.action.startProject": "Start project",
  "billing.action.proforma": "Proforma for the whole proposal",
  "billing.action.raise": "Raise request",
  "billing.action.more": "More actions",
  "billing.action.openClientPage": "Open the client's page",
  "billing.action.back": "Billing",
  "billing.action.edit": "Edit",
  "billing.share.title": "Share with the client",
  "billing.share.hint": "The client opens this link, reads the proposal and accepts it, with no account.",
  "billing.share.link": "Public link",
  "billing.whatsapp.quote": "Hello {name}, here is our proposal {number} for {title}: {total}. You can review and accept it here: {link}",
  "billing.whatsapp.invoice": "Hello {name}, here is {title} ({number}): {total}, due {date}. You can pay by InstaPay, Vodafone Cash or bank transfer. Thank you!",
  "billing.timeline.title": "History",
  "billing.timeline.created": "Created",
  "billing.timeline.sent": "Sent to the client",
  "billing.timeline.accepted": "Accepted by {name}",
  "billing.timeline.acceptedFrom": "{email} · from {ip}",
  "billing.timeline.declined": "Declined",
  "billing.timeline.issued": "Issued",
  "billing.timeline.waiting": "Waiting for the client",
  "billing.planCard.title": "Billing plan",
  "billing.planCard.hint": "Raise each part as a payment request when it falls due.",
  "billing.project.title": "Project",
  "billing.project.none": "No project yet. Starting it from the accepted proposal also creates a milestone for each milestone payment.",
  "billing.project.open": "Open project",
  "billing.startProject.title": "Start the project",
  "billing.startProject.description": "The project takes the client and the title of this proposal.",
  "billing.startProject.key": "Key",
  "billing.startProject.keyHint": "2 to 10 letters or digits, starting with a letter, like NOON.",
  "billing.startProject.keyInvalid": "Use 2 to 10 letters or digits, starting with a letter.",
  "billing.startProject.service": "Service",
  "billing.startProject.done": "Project {key} started",
  "billing.decline.title": "Record the client's decision",
  "billing.decline.description": "The proposal is marked as declined. Its number stays used.",
  "billing.decline.reason": "Reason (optional)",
  "billing.decline.done": "Proposal marked as declined",
  "billing.frozenQuote": "Sent proposals are frozen. Duplicate this one to change anything.",
  "billing.balance.title": "Balance",
  "billing.balance.settled": "Settled in full",
  "billing.payments.title": "Payments",
  "billing.payments.none": "No payments yet.",
  "billing.payments.excess": "{amount} became client credit",
  "billing.credits.title": "Credit notes",
  "billing.credits.kind.correction": "Correction",
  "billing.credits.kind.overpayment": "Overpayment",
  "billing.credits.remaining": "{amount} left",
  "billing.availableCredit": "The client has {amount} of credit in this currency.",
  "billing.notTaxInvoice": "Not a tax invoice. The official tax invoice is issued through the Egyptian Tax Authority's e-invoicing system.",
  "billing.fromQuote": "From proposal {number}",
  "billing.payment.title": "Record a payment",
  "billing.payment.description": "Against {number}. Anything above the balance becomes the client's credit.",
  "billing.payment.method": "Method",
  "billing.payment.amount": "Amount received ({code})",
  "billing.payment.receivedOn": "Received on",
  "billing.payment.reference": "Reference",
  "billing.payment.referenceHint": "The transfer or transaction number.",
  "billing.payment.note": "Note",
  "billing.payment.proof": "Proof of transfer (optional)",
  "billing.payment.proofHint": "PDF, PNG, JPEG or WebP, up to 10 MB.",
  "billing.payment.settles": "Settles {amount}",
  "billing.payment.credit": "{amount} becomes client credit",
  "billing.payment.full": "Pays the balance in full",
  "billing.payment.remaining": "{amount} will remain",
  "billing.payment.egpOnly": "InstaPay and Vodafone Cash move Egyptian pounds only.",
  "billing.payment.invalidAmount": "Enter an amount above zero, with at most 2 decimals.",
  "billing.payment.submit": "Record payment",
  "billing.payment.done": "Payment recorded",
  "billing.payment.proofFailed": "The payment is recorded, but the proof did not upload. Attach it from the payment.",
  "billing.credit.title": "Issue a credit note",
  "billing.credit.description": "It lowers what the client owes on {number}, and gets its own number.",
  "billing.credit.amount": "Amount, VAT included",
  "billing.credit.reason": "Reason",
  "billing.credit.reasonMissing": "Say why, in a few words.",
  "billing.credit.done": "Credit note issued",
  "billing.void.title": "Void this document?",
  "billing.void.description": "A credit note cancels its whole balance. The number stays used, so the series keeps no gap.",
  "billing.void.done": "Document voided",
  "billing.applyCredit.title": "Use client credit",
  "billing.applyCredit.description": "Settle part of {number} from the client's credit of {amount}.",
  "billing.applyCredit.done": "Credit applied",
  "billing.raise.done": "Payment request drafted",
  "billing.proforma.done": "Proforma drafted",
  "billing.error.QUOTE_EXPIRED": "This proposal has expired.",
  "billing.error.QUOTE_ALREADY_DECIDED": "This proposal was already accepted or declined.",
  "billing.error.QUOTE_ALREADY_BILLED": "This proposal is already billed, by a proforma or by its plan.",
  "billing.error.PLAN_ITEM_ALREADY_BILLED": "This part already has a payment request.",
  "billing.error.DOCUMENT_ISSUED": "An issued document cannot change. Correct it with a credit note.",
  "billing.error.QUOTE_NOT_DRAFT": "A sent proposal cannot change. Duplicate it instead.",
  "billing.error.VERSION_CONFLICT": "Someone else changed this. Reload and try again.",
  "billing.error.CREDIT_EXCEEDS_BALANCE": "That is more than the open balance.",
  "billing.error.INSUFFICIENT_CREDIT": "The client does not have that much credit.",
  "billing.error.INVOICE_HAS_PAYMENTS": "It has payments: credit its balance instead of voiding it.",
  "billing.error.METHOD_CURRENCY_MISMATCH": "InstaPay and Vodafone Cash move Egyptian pounds only.",
  "billing.error.PLAN_NOT_BALANCED": "The payment plan must add up to 100%.",
  "billing.error.DOCUMENT_EMPTY": "Add at least one line, or attach a file.",
  "billing.error.FILE_REQUIRED": "Attach a PDF or an image first.",
  "billing.error.FILE_NOT_ATTACHED": "This document has no file attached.",
  "billing.error.CONTRACT_NOT_DRAFT": "Only a draft contract can be changed.",
  "billing.error.CONTRACT_NOT_SENT": "Send the contract before marking it signed or declined.",
  "billing.error.QUOTE_NOT_FILE_ONLY": "This proposal has a public link; the client accepts it there.",
  "billing.error.QUOTE_NOT_STRUCTURED": "A file-only proposal cannot raise invoices.",
  "billing.error.PROJECT_KEY_TAKEN": "Another project already uses that key.",
  "billing.error.PROOF_TYPE_NOT_ALLOWED": "Attach a PDF, PNG, JPEG or WebP.",
  "billing.error.PROOF_TOO_LARGE": "The file is larger than 10 MB.",
  "billing.error.PERMISSION_DENIED": "You do not have permission to do that.",
  "billing.error.VALIDATION_FAILED": "Some fields need attention.",
  "billing.doc.quote": "Proposal",
  "billing.doc.proforma": "Proforma invoice",
  "billing.doc.payment_request": "Payment request",
  "billing.doc.number": "No.",
  "billing.doc.issued": "Date",
  "billing.doc.validUntil": "Valid until",
  "billing.doc.due": "Due",
  "billing.doc.billTo": "Bill to",
  "billing.doc.description": "Description",
  "billing.doc.qty": "Qty",
  "billing.doc.price": "Unit price",
  "billing.doc.discount": "Discount",
  "billing.doc.amount": "Amount",
  "billing.doc.subtotal": "Subtotal",
  "billing.doc.discountTotal": "Discount",
  "billing.doc.vat": "VAT",
  "billing.doc.noVat": "No VAT",
  "billing.doc.total": "Total",
  "billing.doc.paid": "Paid",
  "billing.doc.balance": "Balance due",
  "billing.doc.plan": "Payment plan",
  "billing.doc.payWith": "How to pay",
  "billing.doc.notes": "Notes",
  "billing.doc.terms": "Terms",
  "billing.doc.notTax": "This document is not a tax invoice.",
  "billing.doc.taxId": "Tax registration no.",
  "billing.doc.draft": "Draft",
  "billing.doc.paidStamp": "Paid",
  "billing.doc.voidStamp": "Void",
  "billing.doc.accepted": "Accepted",
  "billing.doc.project": "Project",
  "billing.doc.askDetails": "Ask us for the account details.",
  "billing.doc.instapay": "InstaPay",
  "billing.doc.vodafone": "Vodafone Cash",
  "billing.doc.bank": "Bank transfer",
  "billing.doc.reference": "Use the document number as the transfer reference.",
  "billing.doc.thanks": "Thank you for your business.",
  "billing.public.title": "Proposal {number}",
  "billing.public.for": "Prepared for {client}",
  "billing.public.acceptTitle": "Accept this proposal",
  "billing.public.name": "Your name",
  "billing.public.email": "Your email",
  "billing.public.agree": "I accept this proposal and its terms.",
  "billing.public.accept": "Accept proposal",
  "billing.public.decline": "Decline",
  "billing.public.declineTitle": "Decline this proposal?",
  "billing.public.declineReason": "Tell us why (optional)",
  "billing.public.declined": "You declined this proposal on {date}. Thank you for letting us know.",
  "billing.public.accepted": "Accepted by {name} on {date}. Thank you!",
  "billing.public.next": "We will send you the first payment request shortly.",
  "billing.public.expired": "This proposal expired on {date}. Contact us for an updated one.",
  "billing.public.invalid": "This link is not valid",
  "billing.public.invalidBody": "Ask us for a new link to the proposal.",
  "billing.public.validUntil": "Valid until {date}",
  "billing.public.total": "Total",
  "billing.public.nameMissing": "Enter your name.",
  "billing.public.emailMissing": "Enter a valid email.",
  "billing.public.agreeMissing": "Tick the box to accept.",
  "billing.public.switch": "العربية",
  "billing.public.recorded": "Your acceptance is recorded with its time and your device.",
  "billing.public.questions": "Questions? Write to {email}",
  "billing.public.loading": "Loading the proposal",
  "billing.reports.title": "Billing reports",
  "billing.reports.subtitle": "What clients owe, what came in and where revenue comes from, in each currency on its own.",
  "billing.reports.loadError": "We could not load the reports.",
  "billing.reports.currency": "Currency",
  "billing.ageing.title": "Receivables by age",
  "billing.ageing.hint": "Open balances by days past their due date.",
  "billing.ageing.current": "Not due yet",
  "billing.ageing.range": "{from} to {to} days",
  "billing.ageing.over": "Over {days} days",
  "billing.ageing.byClient": "By client",
  "billing.ageing.empty": "No open balances: everything issued is paid.",
  "billing.ageing.total": "Total open",
  "billing.cash.title": "Cash collected",
  "billing.cash.hint": "Money received per month. Using a client's credit is not new money.",
  "billing.cash.empty": "No payments in the last twelve months.",
  "billing.cash.total": "Twelve months",
  "billing.chart.bar": "{month}: {amount}",
  "billing.revenue.title": "Revenue",
  "billing.revenue.hint": "Billed before VAT, net of credit notes.",
  "billing.revenue.byClient": "By client",
  "billing.revenue.byService": "By service",
  "billing.revenue.period": "Period",
  "billing.revenue.period.90": "90 days",
  "billing.revenue.period.365": "12 months",
  "billing.revenue.period.year": "This year",
  "billing.revenue.empty": "No revenue billed in this period.",
  "billing.revenue.other": "Other",
  "billing.projectCard.title": "Billing",
  "billing.projectCard.billed": "Billed",
  "billing.projectCard.paid": "Paid",
  "billing.projectCard.outstanding": "Outstanding",
  "billing.projectCard.empty": "No proposals or invoices for this project yet.",
  "billing.projectCard.viewAll": "Open billing",
  "billing.projectCard.documents": "Documents",
  "billing.projectCard.loadError": "We could not load this project's billing.",
  "billing.legal.title": "Proformas, not tax invoices",
  "billing.legal.body": "404 OS issues proposals, proformas and payment requests. The official tax invoice for Egyptian clients is issued through the ETA e-invoicing system by the accountant.",
  "billing.tab.expenses": "Expenses",
  "billing.kpi.expenses": "Spent this month",
  "billing.newExpense": "New expense",
  "billing.empty.expenses.title": "No expenses yet",
  "billing.empty.expenses.body": "Record subscriptions, ads, freelancers and office costs. Link one to a project to see its profit.",
  "billing.expenseCategory.software": "Software",
  "billing.expenseCategory.advertising": "Advertising",
  "billing.expenseCategory.freelancers": "Freelancers",
  "billing.expenseCategory.salaries": "Salaries",
  "billing.expenseCategory.office": "Office",
  "billing.expenseCategory.equipment": "Equipment",
  "billing.expenseCategory.travel": "Travel",
  "billing.expenseCategory.fees": "Fees",
  "billing.expenseCategory.other": "Other",
  "billing.expenses.search": "Search by description or vendor",
  "billing.expenses.category": "Category",
  "billing.expenses.allCategories": "All categories",
  "billing.expenses.project": "Project",
  "billing.expenses.allProjects": "All projects",
  "billing.expenses.col.expense": "Expense",
  "billing.expenses.col.category": "Category",
  "billing.expenses.col.project": "Project",
  "billing.expenses.receipt.open": "Open receipt",
  "billing.expenses.edit": "Edit {name}",
  "billing.expenses.delete": "Delete {name}",
  "billing.expenses.deleteTitle": "Delete this expense?",
  "billing.expenses.deleteBody": "“{name}” and its receipt will be removed. This cannot be undone.",
  "billing.expenses.deleteConfirm": "Delete expense",
  "billing.expenses.deleting": "Deleting…",
  "billing.expenses.deleted": "Expense deleted",
  "billing.expenseDialog.newTitle": "New expense",
  "billing.expenseDialog.editTitle": "Edit expense",
  "billing.expenseDialog.description": "Record what the agency spent, in the currency it was paid in.",
  "billing.expenseDialog.category": "Category",
  "billing.expenseDialog.what": "What was it for?",
  "billing.expenseDialog.whatPlaceholder": "Figma, 3 seats for October",
  "billing.expenseDialog.vendor": "Vendor (optional)",
  "billing.expenseDialog.vendorPlaceholder": "Who was paid",
  "billing.expenseDialog.amount": "Amount",
  "billing.expenseDialog.currency": "Currency",
  "billing.expenseDialog.spentOn": "Date",
  "billing.expenseDialog.project": "Project (optional)",
  "billing.expenseDialog.projectHint": "Counts against the project's profit.",
  "billing.expenseDialog.notes": "Notes (optional)",
  "billing.expenseDialog.receipt": "Receipt (optional)",
  "billing.expenseDialog.receiptHint": "PDF, PNG, JPEG or WebP, up to 10 MB.",
  "billing.expenseDialog.receiptCurrent": "Attached: {name}",
  "billing.expenseDialog.receiptReplace": "Choosing a file replaces it.",
  "billing.expenseDialog.receiptRemove": "Remove receipt",
  "billing.expenseDialog.receiptRemoved": "Receipt removed",
  "billing.expenseDialog.receiptFailed": "The expense is saved, but the receipt did not upload. Try attaching it again.",
  "billing.expenseDialog.create": "Record expense",
  "billing.expenseDialog.save": "Save changes",
  "billing.expenseDialog.saving": "Saving…",
  "billing.expenseDialog.created": "Expense recorded",
  "billing.expenseDialog.saved": "Expense saved",
  "billing.expenseDialog.errors.what": "Say what the money was for.",
  "billing.expenseDialog.errors.amount": "Enter an amount above 0.",
  "billing.expenseDialog.errors.spentOn": "Pick the day it was paid.",
  "billing.error.EXPENSE_NOT_FOUND": "This expense no longer exists.",
  "billing.error.RECEIPT_NOT_FOUND": "This expense has no receipt attached.",
  "billing.projectCard.expenses": "Spent",
  "billing.projectCard.profit": "Profit",
  "billing.projectCard.profitHint": "Paid less spent, per currency.",
  "billing.tab.contracts": "Contracts",
  "billing.contracts.subtitle": "Legal documents filed against a client. Staff mark when they went out and came back signed.",
  "billing.newContract": "New contract",
  "billing.empty.contracts.title": "No contracts yet",
  "billing.empty.contracts.body": "File a Word or PDF contract against a client, then mark it sent and signed.",
  "billing.filter.signed": "Signed",
  "billing.contractStatus.draft": "Draft",
  "billing.contractStatus.sent": "Sent",
  "billing.contractStatus.signed": "Signed",
  "billing.contractStatus.declined": "Declined",
  "billing.contract.new": "New contract",
  "billing.contract.edit": "Edit contract",
  "billing.contract.file": "Contract file",
  "billing.contract.fileHint": "PDF, PNG, JPEG or WebP, up to 10 MB.",
  "billing.contract.fileRequired": "Attach the contract file.",
  "billing.contract.open": "Open file",
  "billing.contract.openSigned": "Open signed copy",
  "billing.contract.signedFile": "Signed copy",
  "billing.contract.signedHint": "Optional scan of the signed pages.",
  "billing.contract.markSent": "Mark as sent",
  "billing.contract.markSigned": "Mark as signed",
  "billing.contract.markDeclined": "Mark as declined",
  "billing.contract.send.title": "Mark this contract as sent?",
  "billing.contract.send.body": "It gets a number and the file can no longer change.",
  "billing.contract.sign.title": "Mark this contract as signed?",
  "billing.contract.sign.body": "Attach the signed scan if you have it. You can mark it signed without one.",
  "billing.contract.decline.title": "Mark this contract as declined?",
  "billing.contract.decline.body": "The client did not sign. This cannot be undone.",
  "billing.contract.sent": "Contract {number} marked as sent.",
  "billing.contract.signed": "Contract marked as signed.",
  "billing.contract.declined": "Contract marked as declined.",
  "billing.contract.created": "Contract saved.",
  "billing.contract.fileOnly": "File",
  "billing.quote.mode.label": "How to write this proposal",
  "billing.quote.mode.build": "Build in 404 OS",
  "billing.quote.mode.file": "Attach a file",
  "billing.quote.mode.fileHint": "Client and title are still required. Line items and the payment plan are not.",
  "billing.quote.file": "Proposal file",
  "billing.quote.fileRequired": "Attach the proposal file.",
  "billing.quote.accept": "Mark as accepted",
  "billing.quote.accept.title": "Mark this proposal as accepted?",
  "billing.quote.accept.body": "The client accepted off-app. This does not create invoices or a project.",
  "billing.quote.accepted": "Proposal marked as accepted.",
  "billing.quote.fileAttached": "File attached"
}
